<template>
  <div style="background-color: #f5f8fa;min-width:1200px;">
    <div class="main_box">
      <div class="title">填写订单信息</div>
      <el-form ref="form" :model="formData" label-width="420px">
        <div class="ticketMsg">
          <p>
            航班号&#x3000;&#x3000;
            <span class="blue">{{baseData.flightNo}}</span>
          </p>
          <p>航班日期&#x3000;{{baseData.useStartDate}}</p>
          <p>开航时间&#x3000;{{baseData.departTime}}</p>
          <el-table :data="list" style="margin-top:10px;">
            <el-table-column label="序号" align="center">
              <template slot-scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="ticketName" label="票名称" align="center"></el-table-column>
            <el-table-column label="价格" align="center">
              <template slot-scope="scope">
                <template>
                  <span>￥{{scope.row.salePrice}}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="数量" align="center" width="120">
              <template slot-scope="scope">
                <el-input-number
                  v-model="formData.orderDetailList[scope.$index].quantity"
                  :min="0"
                  size="mini"
                  @change="handleChange(scope)"
                  style="width:100%;"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="小计" align="center">
              <template slot-scope="scope">
                <span
                  class="highLight bold"
                >￥{{(formData.orderDetailList[scope.$index].quantity * scope.row.salePrice).toFixed(2)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="visitorMsg" v-if="count">
          <div class="headline">游客信息</div>
          <div v-for="(item,index) in list" :key="index">
            <div
              class="subtitle"
              v-if="formData.orderDetailList[index].quantity && item.isRealname === 'T'"
            >
              <span class="blue">{{item.ticketName}}</span>
            </div>
            <div
              class="msgForm"
              v-for="(ite,ind) in formData.orderDetailList[index].orderVisitorList"
              :key="ind"
            >
              <el-form-item
                label="姓名"
                :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }"
              >
                <el-input placeholder="请输入姓名" v-model="ite.visitorName" style="width:340px"></el-input>
              </el-form-item>
              <el-form-item
                label="证件类型"
                :rules="{ required: true, message: '请输入证件号', trigger: 'blur' }"
              >
                <el-select
                  v-model="ite.visitorCertificateType"
                  placeholder="请选择"
                  style="width:110px;margin-right:10px;"
                >
                  <el-option
                    v-for="i in certificateTypes"
                    :key="i.code"
                    :label="i.name"
                    :value="i.code"
                  ></el-option>
                </el-select>
                <el-input
                  placeholder="请输入证件号"
                  v-model="ite.visitorCertificateNo"
                  style="width:220px"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="visitorMsg">
          <div class="headline">联系人信息</div>
          <div class="msgForm">
            <el-form-item
              label="联系手机号"
              prop="contactMobile"
              :rules="{ required: true, message: '请输入手机号', trigger: 'blur' }"
            >
              <el-input v-model="formData.contactMobile" placeholder="请输入电话号码" style="width:340px"></el-input>
            </el-form-item>
            <el-form-item
              label="手机验证码"
              prop="code"
              :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }"
              v-if="codeshow"
            >
              <el-input
                placeholder="请输入验证码"
                v-model="formData.code"
                style="width:210px;margin-right:10px;"
              ></el-input>
              <el-button
                type="primary"
                plain
                style="width:120px;"
                @click="getVerificationCode"
                :disabled="!verificationBtn"
              >
                <template v-if="verificationBtn">发送验证码</template>
                <template v-else>重新获取({{verificationTime}})</template>
              </el-button>
            </el-form-item>
          </div>
        </div>
        <div class="submitOrder">
          <span>
            总数量：
            <span>{{totalNum}}</span>
          </span>&#x3000;
          <span>
            总金额：
            <span class="highLight bold">￥{{total === 0 ? 0:total.toFixed(2)}}</span>
          </span>
          <div class="submitBtn" @click="submitBtn">提交订单</div>
        </div>
      </el-form>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import CopyRight from '../components/CopyRight'
import { validaIDCardNo, validaCellPhone } from '../utils/validate'
import {
  cardtypeList,
  qucikBuyCode,
  queryGoods,
  sendCode,
  checkCode,
  createFeeryOrder
} from '@/api/buyTicket'
import { clearInterval, setInterval } from 'timers'

export default {
  components: {
    CopyRight
  },
  data () {
    return {
      baseData: {
        flightNo: '',
        date: '',
        departTime: ''
      },
      listQuery: {},
      list: [],
      contactRealName: false,
      formData: {
        contactMobile: '',
        code: '',
        orderDetailList: []
      },
      certificateTypes: [],
      verificationBtn: true,
      verificationTime: 60,
      total: 0, // 总价
      totalNum: 0, // 总数量
      count: 0, // 实名制数量
      discount: 0, // 折扣总计
      timer: null,
      codeshow: false,
      flightDetail: {},
      flightLineName: ''
    }
  },
  created () {
    const flightLineId = this.$route.query.flightLineId
    const useStartDate = this.$route.query.useStartDate
    const flightDetail = JSON.parse(
      decodeURIComponent(this.$route.query.flightDetail)
    )
    this.flightLineName = this.$route.query.flightLineName
    this.flightDetail = flightDetail
    this.listQuery = {
      customerId: 'SAN_KE',
      customerType: 'ct_sanke',
      flightLineId,
      flightNo: flightDetail.flightNo,
      useStartDate: useStartDate + ' 00:00:00'
    }
    this.baseData = {
      flightNo: flightDetail.flightNo,
      useStartDate,
      departTime: flightDetail.departTime.split(' ')[1]
    }
    this.cardtypeList()
    this.qucikBuyCode()
    this.getGoods()
  },
  methods: {
    cardtypeList () {
      cardtypeList().then(res => {
        if (res.code === 0) {
          this.certificateTypes = res.data
        } else {
          console.error(res.error)
        }
      })
    },
    qucikBuyCode () {
      qucikBuyCode().then(res => {
        if (res.code === 0) {
          this.codeshow = res.data.value !== 'F'
        } else {
          console.error(res.error)
        }
      })
    },
    handleChange (row) {
      let _this = this
      this.$nextTick(function () {
        _this.computedTotal()
        const data = _this.formData.orderDetailList[row.$index]
        const beforeNum = data.orderVisitorList.length
        const afterNum = data.quantity
        if (row.row.isRealname === 'T') {
          if (afterNum - beforeNum > 0) {
            const temp = afterNum - beforeNum
            for (let i = 0; i < temp; i++) {
              data.orderVisitorList.push({
                address: '',
                certificateImageUrl: '',
                isSupportPrint: 'T',
                outTicketNo: '',
                visitorCertificateNo: '',
                visitorCertificateType: '1',
                visitorMobile: '',
                visitorName: ''
              })
            }
          } else {
            const temp = beforeNum - afterNum
            data.orderVisitorList.splice(beforeNum - temp, temp)
          }
        }
      })
    },
    // 计算总价
    computedTotal () {
      this.total = 0
      this.count = 0
      this.totalNum = 0
      for (const index in this.list) {
        this.total +=
          (
            (this.list[index].salePrice - this.list[index].rebatePrice).toFixed(
              2
            ) * this.formData.orderDetailList[index].quantity
          ).toFixed(2) * 1
        this.list.forEach(item => {})
        this.totalNum += this.formData.orderDetailList[index].quantity
        if (this.list[index].isRealname === 'T') {
          this.count += this.formData.orderDetailList[index].quantity
        }
      }
    },
    getGoods () {
      queryGoods(this.listQuery).then(res => {
        if (res.code === 0) {
          this.list = res.data
          this.list.forEach(val => {
            this.formData.orderDetailList.push({
              arrivalPort: this.flightDetail.arrivePort,
              boardingPort: this.flightDetail.departPort,
              currentSalePrice: val.salePrice,
              flightCalendarId: this.flightDetail.dailyFlightGid,
              flightDepartureTime: this.flightDetail.departTime + ':00',
              flightLineId: this.listQuery.flightLineId,
              flightLineName: this.flightLineName,
              flightNo: this.flightDetail.flightNo,
              orderVisitorList: [],
              quantity: 0,
              ticketId: val.ticketId,
              ticketKindId: val.ticketKindId,
              useStartDate: this.listQuery.useStartDate
            })
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    submitBtn () {
      if (this.validateInfo()) {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.codeshow) {
              const data = {
                code: this.formData.code,
                mobilePhone: this.formData.contactMobile,
                templateId: 'SMS_T_BUYCODE'
              }
              checkCode(data).then(res => {
                if (res.code === 0) {
                  this.saveOrder()
                } else {
                  this.$message({
                    message: res.error,
                    type: 'error'
                  })
                }
              })
            } else {
              this.saveOrder()
            }
          }
        })
      }
    },
    validateInfo () {
      let flag = true
      if (this.formData.orderDetailList.some(val => val.quantity > 0)) {
        this.formData.orderDetailList.forEach((value, index) => {
          if (this.list[index].isRealname === 'T') {
            for (let i = 0; i < value.orderVisitorList.length; i++) {
              const val = value.orderVisitorList[i]
              if (val.visitorName == null || val.visitorName === '') {
                this.$message({
                  message: `${this.list[index].ticketName}游客${i +
                    1}姓名不能为空`,
                  type: 'error'
                })
                flag = false
                break
              } else if (val.visitorCertificateType == null || val.visitorCertificateType === '') {
                this.$message({
                  message: `${this.list[index].ticketName}游客${i +
                    1}证件号类型不能为空`,
                  type: 'error'
                })
                flag = false
                break
              } else if (Number(val.visitorCertificateType) === 1) {
                if (val.visitorCertificateNo == null || val.visitorCertificateNo === '') {
                  this.$message({
                    message: `${this.list[index].ticketName}游客${i +
                      1}证件号不能为空`,
                    type: 'error'
                  })
                  flag = false
                  break
                } else if (!validaIDCardNo(val.visitorCertificateNo)) {
                  this.$message({
                    message: `${this.list[index].ticketName}游客${i +
                      1}身份证格式不对`,
                    type: 'error'
                  })
                  flag = false
                  break
                }
              }
            }
          }
        })
      } else {
        this.$message({
          message: '请输入购买数量',
          type: 'error'
        })
        flag = false
      }
      if (!flag) {
        return false
      } else {
        return true
      }
    },
    saveOrder () {
      const param = {
        contactCertificateNo: '',
        contactCertificateType: '1',
        contactMobile: this.formData.contactMobile,
        contactName: '',
        customerId: 'SAN_KE',
        guideId: '',
        orderDetailList: this.formData.orderDetailList.filter(item => item.quantity > 0),
        outOrderNo: '',
        receiveDepartmentId: '',
        regionLongcode: '',
        remark: '',
        saleChannelName: '',
        takeTicketNo: ''
      }
      createFeeryOrder(param).then(res => {
        if (res.code === 0) {
          this.$router.push({
            path: '/payOrder',
            query: {
              orderNo: res.data.orderNo,
              goodsNum: this.totalNum,
              total: this.total,
              type: 'ferry'
            }
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getVerificationCode () {
      if (!validaCellPhone(this.formData.contactMobile)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'error'
        })
      } else {
        const data = {
          templateId: 'SMS_T_BUYCODE',
          mobilePhone: this.formData.contactMobile
        }
        sendCode(data).then(res => {
          if (res.code === 0) {
            this.verificationBtn = false
            this.verificationTime = 60
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (--this.verificationTime <= 0) {
                this.verificationBtn = true
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
          }
        })
      }
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
}

.title::before {
  content: "";
  float: left;
  width: 5px;
  height: 28px;
  background-color: #ffe7ae;
  margin-top: 19px;
  margin-right: 10px;
}

.ticketMsg {
  border: 1px solid #ffe7ae;
  padding: 20px 25px 30px 25px;
  background-color: #fff;
  margin-bottom: 20px;
}

.ticketMsg p {
  font-size: 18px;
  font-weight: bold;
  color: #4d4d4d;
  line-height: 30px;
}

.blue {
  color: #21a4ff;
  font-weight: bold;
}

.ticketMsg .el-table {
  color: #4d4d4d;
}

.ticketMsg .el-table::before {
  height: 0;
}

.ticketMsg .el-table /deep/ th {
  background-color: #f5f5f5;
}

.ticketMsg .el-table /deep/ th .cell {
  line-height: 16px;
}

.ticketMsg .el-table /deep/ td {
  background-color: #fcfcfc;
  border-bottom: 5px solid #fff;
}

.visitorMsg {
  border: 1px solid #ccc;
  background-color: #fff;
  margin-bottom: 20px;
}

.headline {
  background-color: #f1f1f1;
  line-height: 36px;
  padding-left: 25px;
  font-weight: bold;
}

.subtitle {
  background-color: #fcfcfc;
  padding-left: 30px;
  line-height: 36px;
  font-weight: bold;
}

.visitorMsg .msgForm {
  margin: 0 30px;
  padding-top: 35px;
  padding-bottom: 13px;
  border-bottom: 1px solid #ccc;
}

.visitorMsg .msgForm:nth-last-child(1) {
  border-bottom: none;
}

.submitOrder {
  position: relative;
  border: 1px solid #ccc;
  height: 60px;
  line-height: 60px;
  color: #4d4d4d;
  background-color: #fff;
  text-align: right;
  padding-right: 185px;
  margin-bottom: 60px;
}

.submitBtn {
  position: absolute;
  top: -1px;
  right: -1px;
  height: 62px;
  width: 165px;
  line-height: 62px;
  text-align: center;
  font-size: 20px;
  background-color: red;
  color: #fff;
  cursor: pointer;
}
.submitBtn:active {
  opacity: 0.8;
}

.el-icon-success {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: goldenrod;
}

.el-icon-error {
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  color: red;
}
</style>
